import { AnyAction } from 'redux'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { onAbort, processRequest, requestWrapper as request } from "helpers/fetch"
import { t } from "helpers/localization"
import settings from "settings"
import { TYPE_GLOBAL_SEARCH } from "../Actions/ActionClanRating"
import { State } from '~/Reducers';

export const SEARCH_CHANGE_BATTLE_TYPE = 'SEARCH_CHANGE_BATTLE_TYPE'
export const changeBattleType = (battleType: string): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: SEARCH_CHANGE_BATTLE_TYPE,
    battleType
  })
}

export const SEARCH_CHANGE_PAGE = 'SEARCH_CHANGE_PAGE'
export const changePage = (page: any): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: SEARCH_CHANGE_PAGE,
    page
  })
}

export const SEARCH_CLEAR_STATE = 'SEARCH_CLEAR_STATE'
export const clearSearchState = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: SEARCH_CLEAR_STATE
  })
}

export const SEARCH_START_FETCHING = 'SEARCH_START_FETCHING'
export const startFetching = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: SEARCH_START_FETCHING
  })
}

export const SEARCH_UPDATE_RESULT = 'SEARCH_UPDATE_RESULT'
export const updateSearchResult = (data: any): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: SEARCH_UPDATE_RESULT,
    data
  })
}

export const SEARCH_UPDATE_ERROR = 'SEARCH_UPDATE_ERROR'
export const updateError = (error?: any): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: SEARCH_UPDATE_ERROR,
    error
  })
}

export const SEARCH_CHANGE_TERM = 'SEARCH_CHANGE_TERM'
export const changeTerm = (term: any): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: SEARCH_CHANGE_TERM,
    term
  })
}

export const SEARCH_APPEND_TERM_TO_HISTORY = 'SEARCH_APPEND_TERM_TO_HISTORY'
export const appendTermToHistory = (item: any, accountId: number): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: SEARCH_APPEND_TERM_TO_HISTORY,
    item,
    accountId
  })
}

export const fetchSearchResult = (type: any): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {

  const state = getState()

  if (state.searchResult.isFetching) {
    return
  }

  dispatch(startFetching())
  const limit = settings.search.limit

  let url
  let query

  if (type === 'clansRating') {
    url = state.urls.ladderClanSearch.replace('{query}', state.searchResult.term)
    url = `${url}?realm=${state.clansRating.currentRealm || TYPE_GLOBAL_SEARCH}`
    query = {
      offset: (state.searchResult.page - 1) * limit,
      limit: limit,
      season: state.clansRating.currentSeason
    }
  } else {
    url = state.urls.searchList
    query = {
      battle_type: state.searchResult.battleTypeSelected,
      offset: (state.searchResult.page - 1) * limit,
      limit: limit,
      search: state.searchResult.term
    }
  }

  const req = request(url, { query })
  onAbort(req, () => {
    dispatch(updateError())
  })
  processRequest(req).then(json => {
    if (json.error) {
      dispatch(updateError(json))
    } else {
      dispatch(updateSearchResult(json))
    }
  }).catch(() => {
    dispatch(updateError({ error: t('Произошла ошибка. Повторите попытку позже') }))
  })
  return req
}